import api from "./api";

function parseUserFromData(data) {
  return {
    email: data.email,
    permissions: data.permissions,
    id: data.userId,
    avatar: data.avatar,
  };
}

function parseAuthResponse(res) {
  const { data, token } = res.data;
  return { token, user: parseUserFromData(data) };
}

export async function signInRequest(credentials) {
  return api
    .post(`/login`, credentials)
    .then((res) => {
      const responseData = res.data;

      if (responseData.totpPending) {
        return {
          totpPending: true,
          totpAction: responseData.totpAction,
          totpToken: responseData.token,
        };
      }

      const { data, token } = responseData;
      return { token, user: parseUserFromData(data) };
    })
    .catch((err) => {
      return err.response.data;
    });
}

export async function recoverUserInformation() {
  return api
    .get(`/login`)
    .then((res) => {
      const { data } = res.data;
      return { user: data };
    })
    .catch((err) => {
      console.log(err);
      return { error: "Error" };
    });
}

export async function totpSetupRequest(totpToken) {
  return api
    .post(
      `/login/totp/setup`,
      {},
      {
        headers: { Authorization: `Bearer ${totpToken}` },
      }
    )
    .then((res) => res.data)
    .catch((err) => err.response?.data || { error: "Error" });
}

export async function totpConfirmRequest(totpToken, code) {
  return api
    .post(
      `/login/totp/confirm`,
      { code },
      {
        headers: { Authorization: `Bearer ${totpToken}` },
      }
    )
    .then((res) => parseAuthResponse(res))
    .catch((err) => {
      throw enrichApiError(err);
    });
}

export async function totpVerifyRequest(totpToken, code) {
  return api
    .post(
      `/login/totp/verify`,
      { code },
      {
        headers: { Authorization: `Bearer ${totpToken}` },
      }
    )
    .then((res) => parseAuthResponse(res))
    .catch((err) => {
      throw enrichApiError(err);
    });
}

function enrichApiError(err) {
  const data = err.response?.data || err;
  const error =
    typeof data === "object" && data !== null
      ? { ...data }
      : { message: String(data) };

  if (err.response?.status) {
    error.status = err.response.status;
  }

  return error;
}

export async function reset2faRequest(userId) {
  return api
    .post(`/admin/users/${userId}/reset-2fa`)
    .then((res) => res.data)
    .catch((err) => {
      throw err.response?.data || err;
    });
}
